/*eslint-env jquery*/
import React, { Component } from 'react'
import { attachmentsService } from '../../_services/attachments.service'
import { toastr } from 'react-redux-toastr'
import  config  from '../../config'
import { FiEdit } from 'react-icons/fi'
const uploadsUrl = config.uploadsUrl


class PicUploader extends Component {

  constructor(props) {
    super(props);
    this.state = {
      previewImage: '',
      loading: false,
      logoId: '',
      value: this.props.value
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = () => {

    if (this.props.defaultValue) {

      // if (this.props.value) {
      //   let file = this.props.value;
      //   if (file) {

      //     let reader = new FileReader();

      //     reader.onloadend = () => {
      //       this.setState({ previewImage: reader.result, loading: false });
      //     }
      //     reader.readAsDataURL(file);

      //   }
      // } else {
        this.setState({ previewImage: uploadsUrl+this.props.defaultValue, loading: false });
      // }

    }
  }

  async componentWillReceiveProps(nextProps) {
    // if (nextProps.defaultValue && nextProps.defaultValue !== this.props.defaultValue) {
      // this.setState({ loading: true, value: nextProps.value });

      // await attachmentsService.getById(nextProps.value)
      //   .then((res) => {
        if (nextProps.value) {
          // console.log(nextProps)
          this.setState({ previewImage: uploadsUrl+nextProps.defaultValue, loading: false });
        }


      //   })
      //   .catch((error) => {
      //     // console.log(error)
      //     // this.handleError(error)
      //   });
    // }
  }


  _handleImageChange = e => {
    e.preventDefault();
    this.setState({ loading: true });
    //Generate Preview Image
    let files = Array.from(e.target.files);
    let file = e.target.files[0];
    if (file) {
      if (file.size > (1024 * 1024 * 1)) {
        toastr.error('حجم تصویر نباید بیشتر از 1 مگابایت باشد');
        this.setState({ loading: false });
      } else if (file.name.split('.').pop().toUpperCase() !== 'JPG' && file.name.split('.').pop().toUpperCase() !== 'JPEG' && file.name.split('.').pop().toUpperCase() !== 'PNG') {
        toastr.error('فقط تصاویر jpg پشتیبانی می شود');
        this.setState({ loading: false });
      } else {

        // var img = new Image();
        // img.onload = function() {
        //   // console.log("This image has width "+this.width+"px and height "+this.height+"px.");
        // }
        // img.src = file;

        // this.props.onChange(file)

        const formData = new FormData();
        formData.append('file', file);
        // formData.append('width', '');
        // formData.append('height', '');
        formData.append('needCompresstion', false);
        // // console.log(file);


        attachmentsService.upload(formData)
          .then((res) => {
            this.setState({ logoId: res.data.id, loading: false });
            // toastr.success('ثبت راننده حمل و نقل جدید', ' حمل و نقل جدید  "' + res.data.userName +  '" با موفقیت ثبت شد');
            // // console.log(res.data);

            this.props.onChange(res.data);
            // console.log(res.data)

            files.forEach((file, i) => {
              let reader = new FileReader();

              reader.onloadend = () => {
                this.setState({ previewImage: reader.result, loading: false });
              }
              reader.readAsDataURL(file);
            })
          })
          .catch((error) => {
            // console.log(error)
            // this.handleError(error)
          });
      }
    }

  }

  getFileExtension(filename) {
    return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
  }
  _handleClick = (e) => {
    var inputField = this.refs.fileField;
    inputField.click()
  }
  // shouldComponentUpdate(){
  //   return false;
  // }

  render() {
    // const { isOpen } = this.state;

    return (
      <div className="file-area-liner">
        <input ref="fileField" type="file" accept='image/*' onChange={this._handleImageChange} />
        <div className="file-dummy">
          <div className={"success " + (this.state.previewImage === '' ? "hidden" : "")}>
            <img src={this.state.previewImage} alt="" className={"previewImage " + (this.state.previewImage === '' ? "hidden" : "")} />
          </div>
          <div className={"default " + (this.state.previewImage !== '' ? "hidden" : "")}><span>{this.props.label}</span>
          </div>

        </div>
        <a className="btn btn-primary btn-sm uploadBtn" onClick={this._handleClick}><FiEdit size="20px"/></a>
        <input type="hidden" name={this.props.name} defaultValue={this.state.logoId} />
        {this.state.loading && <div className="indicator" style={{ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0 }}>
          <div className="PicLoader PicLoader3" >

          </div>
        </div>}
      </div>
    );
  }
}
export default PicUploader;
